import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, RouterModule, NavigationEnd } from '@angular/router';
import { CoreService } from '../../../../services/core.service';
import { TablerIconsModule } from 'angular-tabler-icons';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-branding',
  standalone: true,
  imports: [RouterModule, TablerIconsModule],
  // Sidebar home/logo automation ids 19/10/2026 DW
  template: `
    <div class="branding d-none d-lg-flex align-items-center">
      @if (showHomeIcon) {
        <a id="sidebar-home-link" [routerLink]="['/dashboards/dashboard1']" class="branding__home-link d-flex align-items-center p-2" aria-label="Home">
          <i-tabler name="home" class="icon-24 d-flex"></i-tabler>
        </a>
      } @else {
        <a id="sidebar-home-link" [routerLink]="['/']" class="d-flex">
          <img
            src="./assets/images/logos/amberwithslogan.webp"
            class="align-middle m-2"
            alt="logo"
          />
        </a>
      }
    </div>
  `,
  styles: [`
    .branding__home-link {
      color: #000000;
    }
    .branding__home-link i-tabler {
      color: inherit;
    }
  `]
})
export class BrandingComponent implements OnInit, OnDestroy {
  options = this.settings.getOptions();
  showHomeIcon = false;
  private sub?: Subscription;

  constructor(
    private settings: CoreService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.updateShowHomeIcon();
    this.sub = this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(() => this.updateShowHomeIcon());
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  private updateShowHomeIcon(): void {
    this.showHomeIcon = this.router.url.includes('dashboards/dashboard1');
  }
}
